/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const urlEndings = {
  "AWS::S3::Bucket": { url: "", type: "s3", callType: "s3" },
  "AWS::VPC::EC2": { url: "vpcs:sort=VpcId", type: "vpc", callType: "default" },
  "AWS::EC2::VPC": { url: "vpcs:sort=VpcId", type: "vpc", callType: "default" },
  "AWS::EC2::NetworkInterface": {
    url: "NIC:sort=description",
    type: "ec2",
    callType: "default",
  },
  "AWS::EC2::Instance": {
    url: "Instances:sort=instanceId",
    type: "ec2",
    callType: "default",
  },
  "AWS::EC2::Volume": {
    url: "Volumes:sort=desc:name",
    type: "ec2",
    callType: "default",
  },
  "AWS::EC2::SecurityGroup": {
    url: "SecurityGroups:sort=groupId",
    type: "ec2",
    callType: "default",
  },
  "AWS::ElasticLoadBalancingV2::LoadBalancer": {
    url: "LoadBalancers:",
    type: "ec2",
    callType: "default",
  },
  "AWS::EC2::EIP": {
    url: "Addresses:sort=PublicIp",
    type: "ec2",
    callType: "default",
  },
  "AWS::ApiGateway::RestApi": { url: "", callType: "apigateway" },
  "AWS::Lambda::Function": { callType: "lambda" },
  "AWS::AutoScaling::AutoScalingGroup": { callType: "autoscaling" },
} as const;

export const resourceTypeMap = {
  "ec2/elasticip": "AWS::EC2::EIP",
  "ec2/instance": "AWS::EC2::Instance",
  "ec2/network-interface": "AWS::EC2::NetworkInterface",
  "ec2/security-group": "AWS::EC2::SecurityGroup",
  "ec2/volume": "AWS::EC2::Volume",
  "ec2/vpc": "AWS::EC2::VPC",

  "lambda/function": "AWS::Lambda::Function",

  s3: "AWS::S3::Bucket",
  "s3/storage-lens": "AWS::S3::Bucket",

  "elasticloadbalancing/loadbalancer":
    "AWS::ElasticLoadBalancingV2::LoadBalancer",

  "apigateway/restapis": "AWS::ApiGateway::RestApi",

  "ec2/vpc-endpoint": "AWS::VPC::EC2",
} as const;

export const providerTooltipMap = {
  AZURE: "Open in Azure portal",
  AWS: "Show in console",
  GCP: "Open in Google Cloud console",
} as const;
